export function openRemoteController() { throw new Error('Open Remote projects in the Gab AI mobile app.'); }
